function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7556 14.0093C16.7556 14.0093 9.28072 14.0209 9.28072 14.0381H7C7.36205 14.0447 9.09149 14.1692 9.28072 15.9207L9.28176 32.8346H17.0287C18.4138 32.8346 22.7224 32.2881 22.7224 27.8762C22.7224 23.4645 17.9398 22.7438 17.9398 22.7438C18.6693 22.7438 21.8922 22.0551 21.8922 18.5459C21.8922 14.3114 18.155 14 17.0559 14C16.8665 14 16.7556 14.0093 16.7556 14.0093ZM12.863 15.8318L14.9142 15.8248C14.9142 15.8248 18.3022 15.8306 18.3022 18.6999C18.3022 21.8693 15.5855 21.8983 14.8799 21.8983H12.8777C12.8777 21.8983 12.863 16.9948 12.863 15.8318ZM12.863 23.6966L15.038 23.6886C15.038 23.6886 19.0832 23.696 19.0832 27.1216C19.0832 30.9043 15.8393 30.94 14.9973 30.94H12.8806C12.8806 30.94 12.863 25.0857 12.863 23.6966Z",
  fill: "#002D59"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.053 26.7246V26.5029C114.053 26.5029 114.052 26.5855 114.053 26.7246Z",
  fill: "#002D59"
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 114,
  y: 24,
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114 24.3706V24C114 24 113.999 24.138 114 24.3706Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114 24.3706H114.002V24H114V24.3706Z",
  fill: "#002D59"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.7825 11.902C84.7825 11.902 77.1419 11.9147 77.1419 11.9335H74.8105C75.1813 11.9407 76.9486 12.0767 77.1419 13.9905L77.1425 32.4714H85.0623C86.4783 32.4714 90.8815 31.8742 90.8815 27.0536C90.8815 22.2332 85.9934 21.4456 85.9934 21.4456C86.7384 21.4456 90.0328 20.6932 90.0328 16.8589C90.0328 12.232 86.2127 11.8918 85.0897 11.8918C84.8959 11.8918 84.7825 11.902 84.7825 11.902ZM80.8044 13.8933L82.9 13.8857C82.9 13.8857 86.3635 13.892 86.3635 17.0271C86.3635 20.4901 83.5867 20.5218 82.8652 20.5218H80.8184C80.8184 20.5218 80.8044 15.1641 80.8044 13.8933ZM80.8044 22.4867L83.0264 22.4781C83.0264 22.4781 87.1622 22.4861 87.1622 26.2291C87.1622 30.3622 83.8459 30.4012 82.9852 30.4012H80.8214C80.8214 30.4012 80.8044 24.0045 80.8044 22.4867Z",
  fill: "#002D59"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.0745 11.8918C47.4677 11.8988 49.4245 12.0493 49.4245 14.2992C49.4245 15.0066 49.431 21.6415 49.4355 26.1184C49.431 26.5786 49.2775 30.4636 45.3963 30.4636C42.0133 30.4636 42.0153 26.0252 42.0153 26.0252H42.0012C42.008 25.8646 42.0048 17.1057 42.0004 13.6497C41.9562 11.7615 40.1672 11.944 40.1672 11.944V11.9254C38.4947 11.9109 36.2416 11.8918 35.9849 11.8918C36.3781 11.8988 38.3351 12.0493 38.3351 14.2992C38.3351 15.3775 38.3504 25.9056 38.3504 25.9056C38.3622 25.9567 37.7369 32.94 45.6154 32.94C45.6154 32.94 53.1032 33.3546 53.1059 26.0774L53.1093 26.0732C53.1093 24.9942 53.0943 11.8918 53.0943 11.8918H47.0745Z",
  fill: "#002D59"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.3279 14.3003V32.4623C56.3279 32.4623 65.2132 32.4629 68.16 32.4587C70.065 32.42 69.8811 30.6345 69.8811 30.6345H69.8985C69.9138 28.969 69.934 27.2038 69.934 26.9475C69.9257 27.3389 69.7752 29.2868 67.5141 29.2868C66.7506 29.2868 62.4596 29.2938 59.9909 29.2978V23.6244H67.6611V20.836H59.9909V15.1184C62.2178 15.1224 66.661 15.13 67.4668 15.13C69.727 15.13 69.8784 17.0782 69.8849 17.4696V11.9533C69.8849 11.9533 54.5518 11.8918 53.9773 11.8918C54.3703 11.8999 56.3279 12.0503 56.3279 14.3003Z",
  fill: "#002D59"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M101.052 11.8918C101.444 11.8988 103.401 12.0493 103.401 14.2992C103.401 15.0066 103.408 21.6415 103.412 26.1184C103.407 26.5786 103.255 30.4636 99.3727 30.4636C95.9898 30.4636 95.9923 26.0252 95.9923 26.0252H95.9779C95.9853 25.8646 95.9817 17.1057 95.977 13.6497C95.9327 11.7615 94.1445 11.944 94.1445 11.944V11.9254C92.4714 11.9109 90.2186 11.8918 89.9622 11.8918C90.3552 11.8988 92.3119 12.0493 92.3119 14.2992C92.3119 15.3775 92.3527 26.0005 92.3657 26.0484C92.3657 26.0484 91.7138 32.94 99.5914 32.94C99.5914 32.94 107.08 33.3546 107.083 26.0774L107.087 26.0732C107.087 24.9942 107.072 11.8918 107.072 11.8918H101.052Z",
  fill: "#002D59"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.688 13.2531C110.461 14.1614 109.848 15.3942 109.848 16.9529C109.848 18.0587 110.137 19.0254 110.714 19.8543C111.293 20.6831 112.26 21.4828 113.618 22.2515L117.358 24.4427C118.432 25.0938 119.222 25.6958 119.729 26.2483C120.225 26.788 120.477 27.4437 120.487 28.2115C120.466 29.8288 117.849 30.4059 116.705 30.4059C114.834 30.4059 113.533 30.1259 112.064 28.9895C110.172 27.528 109.848 25.3784 109.848 25.3784V28.8425C109.848 29.5529 110.199 30.1783 110.9 30.7214C111.602 31.2642 112.506 31.6784 113.612 31.9653C114.718 32.2508 115.865 32.3942 117.056 32.3942C119.246 32.3942 120.995 31.9564 122.271 31.033C122.287 31.0216 122.302 31.0083 122.318 30.9959L122.328 30.9988C123.132 30.4076 123.691 29.6797 124.008 28.8175C124.193 28.3573 124.305 27.8616 124.307 27.3475C124.315 27.2195 124.32 27.0901 124.32 26.9581C124.32 25.8923 124.011 24.9801 123.393 24.22C122.775 23.4608 121.756 22.6761 120.337 21.8674L116.598 19.7064C115.483 19.0751 114.677 18.5069 114.181 18.0048C113.684 17.5009 113.436 16.8644 113.436 16.0946C113.436 14.4615 115.899 13.8794 116.992 13.8794C118.777 13.8794 120.017 14.1604 121.417 15.2955C123.221 16.7571 123.529 18.9066 123.529 18.9066V15.4434C123.529 14.7334 123.195 14.1067 122.526 13.5635C121.857 13.0217 120.995 12.6069 119.942 12.3204C118.887 12.0351 117.793 11.8918 116.658 11.8918C114.57 11.8918 112.914 12.3453 111.688 13.2531Z",
  fill: "#002D59"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7273 11.8918C23.1199 11.899 25.0779 12.0493 25.0779 14.2994V32.4617L37.1616 32.4578V26.9414C37.1542 27.3325 37.0028 29.2805 34.7424 29.2805C34.104 29.2805 28.7216 29.2623 28.7216 29.2623L28.7365 13.6655C28.7365 12.1763 27.6835 11.9263 27.1725 11.8918H22.7273Z",
  fill: "#002D59"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.17573 5.48853C1.49736 5.48853 0.947021 6.03601 0.947021 6.71175V16.4335C0.947021 17.1091 1.49736 17.657 2.17573 17.657C2.85453 17.657 3.40466 17.1091 3.40466 16.4335V7.93434H66.2685C66.9463 7.93434 67.4968 7.38644 67.4968 6.71175C67.4968 6.03601 66.9463 5.48853 66.2685 5.48853H2.17573Z",
  fill: "#002D59"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 22.5784C0 23.9335 1.10344 25.031 2.46507 25.031C3.82669 25.031 4.93077 23.9335 4.93077 22.5784C4.93077 21.2229 3.82669 20.1248 2.46507 20.1248C1.10344 20.1248 0 21.2229 0 22.5784Z",
  fill: "#009FE3"
});

var _ref14 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 68,
  y: 0,
  width: 8,
  height: 12
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.3616 0H75.9608V11.3775H68.3616V0Z",
  fill: "white"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.3616 3.78125C68.3616 5.86954 72.1615 11.3775 72.1615 11.3775C72.1615 11.3775 75.9608 5.86954 75.9608 3.78125C75.9608 1.69274 74.2601 0 72.1615 0C70.0625 0 68.3616 1.69274 68.3616 3.78125ZM69.5183 3.78125C69.5183 2.32855 70.7012 1.15054 72.1615 1.15054C73.621 1.15054 74.8041 2.32855 74.8041 3.78125C74.8041 5.23352 73.621 6.41153 72.1615 6.41153C70.7012 6.41153 69.5183 5.23352 69.5183 3.78125Z",
  fill: "#009FE3"
}));

var SvgBluebuslogo = function SvgBluebuslogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 33,
    viewBox: "0 0 125 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBluebuslogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bluebuslogo.31a50f68.svg";
export { ForwardRef as ReactComponent };